import { __awaiter } from "tslib";
import { ConfigurationStartEvent } from "@plansoft-configuration-renderer/events";
import { handleConfigurationEvent } from "../events/handleConfigurationEvent";
import { setStartOptions } from "../reducers/Additional/configurationOptionsReducer";
import { resetLastChanges } from "../reducers/Additional/lastChangesReducer";
import { decrementOpenRequests, incrementOpenRequests, resetAll, setPath, setSelectors, } from "../reducers/actions";
import { getSelectorDefaults } from "../reducers/selectors";
import { handleCfgStateResponse } from "./handleCfgStateResponse";
import { createPathSelectors } from "./requestDefaults";
export function startConfiguration(startOptions, asyncOptions = {}) {
    return (dispatch_1, getState_1, _a) => __awaiter(this, [dispatch_1, getState_1, _a], void 0, function* (dispatch, getState, { cfgApi }) {
        var _b;
        try {
            const rootState = getState();
            const defaults = getSelectorDefaults(rootState);
            dispatch(resetAll());
            const selectors = startOptions.selectors
                ? startOptions.selectors
                : createPathSelectors("/", defaults);
            // copy parameters to storage
            dispatch(setPath({ path: "/", initial: true }));
            dispatch(setSelectors(selectors));
            dispatch(setStartOptions(startOptions));
            dispatch(resetLastChanges());
            dispatch(incrementOpenRequests());
            const response = yield cfgApi.createConfiguration({
                createConfigurationParams: Object.assign(Object.assign({}, startOptions), { selectors }),
            }, { signal: asyncOptions === null || asyncOptions === void 0 ? void 0 : asyncOptions.abortSignal });
            dispatch(handleCfgStateResponse(response));
            dispatch(handleConfigurationEvent(new ConfigurationStartEvent(response.id)));
        }
        catch (err) {
            // rethrow if not aborted
            if (!((_b = asyncOptions.abortSignal) === null || _b === void 0 ? void 0 : _b.aborted)) {
                throw err;
            }
        }
        finally {
            dispatch(decrementOpenRequests());
        }
    });
}
//# sourceMappingURL=startConfiguration.js.map